import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

const BASE = "https://mira-mirror.ai";
const LANGS = ["de", "en", "es", "it", "fr"];

export default function SeoTags() {
  const { pathname } = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    document.head.querySelectorAll('link[data-seo="hreflang"]').forEach((el) => el.remove());
    const url = (lc) => (lc === "de" ? `${BASE}${pathname}` : `${BASE}${pathname}?lang=${lc}`);
    const add = (rel, href, hreflang) => {
      const l = document.createElement("link");
      l.rel = rel;
      l.href = href;
      if (hreflang) l.hreflang = hreflang;
      l.dataset.seo = "hreflang";
      document.head.appendChild(l);
    };
    LANGS.forEach((lc) => add("alternate", url(lc), lc));
    add("alternate", `${BASE}${pathname}`, "x-default");
    add("canonical", url(lang));
    const og = document.querySelector('meta[property="og:url"]');
    if (og) og.setAttribute("content", url(lang));
  }, [pathname, lang]);

  return null;
}
